import { Button } from '@/atoms/Button'
import { ParagraphSM, TitleSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchApplicationTypes, useTorchApplication } from '../../components/TorchApplicationContext'

export const UploadAcknowledgement = () => {
  const { t } = useTranslate('guild-create')
  const { data, updateData, type } = useTorchApplication()

  const isCompletedMovie = type === TorchApplicationTypes.CompletedMovie

  if (!isCompletedMovie) {
    return null
  }

  const description = isCompletedMovie
    ? t(
        'torchDetailsAcknowledgementDescriptionMovie',
        'All completed films and documentaries must first submit a sample clip as a Torch to the Angel Guild. Once this sample Torch passes the Guild voting process, the full film will then be placed into the Guild for voting. Read the section below to understand the requirements of a Torch. ',
      )
    : t(
        'torchDetailsAcknowledgementDescriptionConcept2',
        'A "Torch" is a representative sample of what your final production will look like. It may take the form of a concept video or a completed episode. Torches must be at least 5 minutes in length and are recommended to be 20 minutes or less (but may be longer). Torches may not be trailers or sizzle reels, but should be a continuous scene (or 2-3 scenes put together) that give the average viewer a good understanding of the plot, tone, and pace of the story. Credits, personal or business names, company logos, websites, or explainer videos from the filmmaker or cast are not allowed to be included with a Torch.',
      )

  if (data?.uploadAcknowledgements?.includes('movie')) {
    return <ParagraphSM>{description}</ParagraphSM>
  }

  const onAcknowledge = () => {
    updateData({ uploadAcknowledgements: (data?.uploadAcknowledgements || []).concat(['movie']) })
  }

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-info-300 bg-info-100 p-4">
      <TitleSM weight="bold">{t('readCarefullyBeforeUploading', 'Read Carefully Before Uploading!')}</TitleSM>
      <ParagraphSM>{description}</ParagraphSM>
      <div>
        <Button variant="core-gray-900" onClick={onAcknowledge}>
          {t('iUnderstand', 'I Understand')}
        </Button>
      </div>
    </div>
  )
}
